var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGnbLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 29,
    viewBox: "0 0 150 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "40xpb5owaa",
    d: "M0 0h21.545v22.294H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M33.364 5.878v5.698h6.476v16.098h7.456V11.576h6.475V5.878zM68.49 15.982c-.506.446-1.264.669-2.275.669h-2.717v-5.106h2.717c1.011 0 1.77.223 2.275.669.506.447.758 1.074.758 1.884 0 .81-.252 1.438-.758 1.884m7.203 2.195c.716-1.162 1.074-2.522 1.074-4.079 0-1.66-.41-3.113-1.232-4.36-.822-1.244-1.99-2.199-3.507-2.863-1.517-.665-3.296-.997-5.339-.997H56.043v21.796h7.455v-5.48h2.023l3.759 5.48h7.96l-4.643-6.725c1.347-.686 2.379-1.609 3.096-2.772"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.864 5.878)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tfhsquj3lb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#40xpb5owaa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.216 11.77c0 1.598-.29 2.76-.869 3.487-.579.727-1.417 1.09-2.511 1.09-1.096 0-1.933-.363-2.512-1.09-.58-.726-.869-1.889-.869-3.488V0H0v11.988c0 3.259.947 5.79 2.843 7.597 1.896 1.806 4.538 2.709 7.93 2.709 3.39 0 6.033-.903 7.929-2.71 1.895-1.806 2.843-4.337 2.843-7.596V0h-7.33v11.77z",
    fill: "#FEFEFE",
    mask: "url(#tfhsquj3lb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.206 11.327c1.853 0 3.464.852 4.833 2.554l4.707-4.142c-1.095-1.412-2.484-2.491-4.17-3.239-1.685-.746-3.6-1.12-5.749-1.12-2.338 0-4.444.483-6.319 1.448-1.874.965-3.343 2.315-4.406 4.048-1.064 1.733-1.596 3.7-1.596 5.9s.532 4.167 1.596 5.9c1.063 1.734 2.532 3.083 4.406 4.048 1.875.965 3.981 1.448 6.32 1.448 2.147 0 4.063-.373 5.749-1.12 1.685-.748 3.074-1.828 4.17-3.24l-4.708-4.14c-1.369 1.702-2.98 2.553-4.833 2.553-1.559 0-2.811-.493-3.76-1.48-.947-.985-1.421-2.308-1.421-3.97 0-1.66.474-2.983 1.422-3.969.948-.986 2.2-1.479 3.76-1.479M140.712 15.468l8.846-9.59h-8.12l-7.265 7.909V5.878h-7.33v21.795h7.33v-5.386l1.674-1.837 5.528 7.223H150zM0 27.854h11.491l3.87-10.597L9.617 1.526zM22.222 1.525l-5.746 15.732 3.87 10.597h11.492zM10.173 0l5.746 15.732L21.664 0z",
    fill: "#FEFEFE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbLogo);
export default __webpack_public_path__ + "static/media/gnb-logo.6ead2ccfe4ec966fc9af89b0d7d0225b.svg";
export { ForwardRef as ReactComponent };